import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Layout from "../component/layout";
import { makeRequest2 } from "../../../utils/makeRequest";
import { toastify } from "../../../utils/toast";
import { getLandlordFacilitiesURL } from "../../../utils/urls";
import { setItem, getItem } from "../../../utils/localStorage";
import { useFacilityStore } from "../../../app/z-store/store";

function Facilities() {
    const navigate = useNavigate();
    const [facilities, setFacilities] = useState([]);
    const setFacilityId = useFacilityStore((state) => state.setFacilityId);

    const getFacilities = async () => {
        try {
            const response = await makeRequest2(getLandlordFacilitiesURL, "GET", {});
            console.log("Facilities response:", response);

            if (response.success) {
                const currentUserValue = await getItem("LANDLORDUSER");

                let currentUser;
                // Check if currentUserValue is a string or an object
                if (typeof currentUserValue === "string") {
                    try {
                        currentUser = JSON.parse(currentUserValue);
                    } catch (err) {
                        console.error("Error parsing LANDLORDUSER:", err);
                        return toastify("Invalid user data.", "error");
                    }
                } else {
                    currentUser = currentUserValue; // Assume it's already parsed
                }

                const role = currentUser?.user?.role;
                if (role !== "guard") {
                    setFacilities(response.data);
                } else {
                    const facilityId = currentUser?.user?.facilityId;
                    const filter = response.data.filter((x) => x._id === facilityId);
                    setFacilities(filter);
                }
            }
        } catch (err) {
            console.error("Error in getFacilities:", err.message);
            toastify("Server error.", "error");
        }
    };

    const handleFacilityClick = async (facility) => {
        try {
            await setItem("selectedFacilityId", facility._id);
            setFacilityId(facility._id);

            // Retrieve the LANDLORDUSER data
            const currentUserValue = await getItem("LANDLORDUSER");
            let currentUser;
            // Check the type of currentUserValue before parsing
            if (typeof currentUserValue === "string") {
                try {
                    currentUser = JSON.parse(currentUserValue);
                } catch (err) {
                    console.error("Error parsing LANDLORDUSER:", err);
                    return toastify("Invalid user data.", "error");
                }
            } else {
                currentUser = currentUserValue; // Assume it's already an object
            }


            // Match selected facility with customerData to get customerId
            const customerData = currentUser?.user?.customerData || [];
            const matchedCustomer = customerData.find((item) => item.facilityId === facility._id);

            if (matchedCustomer) {
                await setItem("selectedCustomerId", matchedCustomer.customerId); // ✅ Set the customerId
                console.log("Customer ID set for facility:", matchedCustomer.customerId);
            } else {
                console.warn("No matching customerId found for facility:", facility._id);
                toastify("No customer record found for this facility.", "error");
            }




            // Handle navigation based on role
            const role = currentUser?.user?.role;
            if (role !== "guard") {
                navigate("/landlord_portal", {
                    state: {
                        facility: {
                            ...facility,
                            logo: facility.logo ? (
                                facility.logo.startsWith('uploads/') ? facility.logo : `uploads/${facility.logo}`
                            ) : null
                        }
                    }
                });
            } else if (role === "guard") {
                navigate("/facility/visitor_access_management/home");
            }
        } catch (err) {
            console.error("Error in handleFacilityClick:", err.message);
            toastify("An error occurred.", "error");
        }
    };






    useEffect(() => {
        getFacilities();
    }, []);

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="#">Facilities</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        {facilities.length === 0 ? (
                            <div className="col-md-12 text-center">
                                <p>No facilities available</p>
                            </div>
                        ) : (
                            facilities.map((facility, index) => (
                                <div className="col-md-3" key={index}>
                                    <div className="pc-component">
                                        <div
                                            className="card mb-2 text-center"
                                            style={{ position: "relative" }}
                                        >
                                            <span
                                                className="badge bg-warning"
                                                style={{ position: "absolute", top: 5, left: 5 }}
                                            >
                                                {index + 1}
                                            </span>
                                            <span className="badge bg-light-primary">
                                                {" "}
                                                <i className="ti ti-home f-50 mt-3"></i>
                                            </span>

                                            <div
                                                className="card-body"
                                                onClick={() => handleFacilityClick(facility)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <h5 className="card-title">{facility.name}</h5>
                                                <p className="card-text">
                                                    <span className="badge bg-light-primary">
                                                        {facility.location}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Facilities;
